import { HTMLAttributes } from 'react';

interface SectionItemBoxType extends HTMLAttributes<HTMLDivElement> {
  show: boolean | string | null;
}

const SectionItemBox = ({ children, className, show, ...props }: SectionItemBoxType) => {
  if (children == null || !show || show == '') return; // if no entry, then return no Box
  return (
    <div
      className={`bg-grey-info p-2 px-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default SectionItemBox;
